export default "__VITE_ASSET__759ce039__"